import { Box } from '@/shared/ui';

import AddApp from '@/assets/icons/AddApp';
import { GX_TEXT_DISABLED } from '@/config/colors';
import Typography from '@/shared/ui/typography/Text';

type AddAppButtonProps = {
  onClick: () => void;
};
export const AddAppButton = ({ onClick }: AddAppButtonProps) => {
  return (
    <Box
      component='button'
      sx={{
        minHeight: '40vh',
        p: 0,
        backgroundColor: 'gx.tileDark',
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer',
        gap: 1,
        border: 'none',
        color: 'gx.text',
        fontFamily: theme => theme.typography.fontFamily,
        transition:
          'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        '&:hover': {
          backgroundColor: 'gx.tileDark'
        }
      }}
      onClick={onClick}
    >
      <Box
        sx={{
          width: 112,
          height: 48,
          borderBottomColor: 'gx.highlight',
          borderBottomWidth: 2,
          borderBottomStyle: 'solid',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'gx.tileLight',
          color: 'gx.textDisabled'
        }}
      >
        Tab
      </Box>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          flex: 1,
          flexDirection: 'column',
          gap: 2
        }}
      >
        <Box
          sx={{
            width: '64px',
            height: '64px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'gx.tileLight'
          }}
        >
          <AddApp
            fill={GX_TEXT_DISABLED}
            sx={{
              width: '24px',
              height: '24px'
            }}
          />
        </Box>
        <Typography
          size={14}
          sx={{ color: 'gx.textDisabled' }}
        >
          Your app will appear here
        </Typography>
      </Box>
    </Box>
  );
};
